import React from 'react';
import Mixpanel from 'helpers/Mixpanel.js';
import ContentCard from 'components/Global/Card/ContentCard.jsx';
import {
  EntityLabelContainer,
  EntitySection,
  EntityFeedContainer,
  StyledEntityName,
  StyledEntityTypeLabel,
  StyledSubscribeLabel,
  StyledEntityIcon,
} from '../styled.js';

const EntityContentBlock = ({ data }) => {
  const { entity = {}, contents = [] } = data;
  return (
    <EntitySection>
      <EntityLabelContainer>
        <StyledEntityIcon
          onClick={() => { Mixpanel.track('clicked icon on Entity Content Block', { id: entity.public_id, name: entity.name }); }}
          logo_url={entity.logo_url} to={`/blueprint/${entity.type}/${entity.public_id}`}
        />
        <StyledEntityName
          onClick={() => { Mixpanel.track('clicked name on Entity Content Block', { id: entity.public_id, name: entity.name }); }}
          to={`/blueprint/${entity.type}/${entity.public_id}`}
        >{entity.name}</StyledEntityName>
        {entity.is_subscribed || entity.is_competitor ? (
          <StyledSubscribeLabel>{entity.is_competitor ? 'Competitor' : 'Subscribed'}</StyledSubscribeLabel>
        ) : null}
        <StyledEntityTypeLabel>{entity.type}</StyledEntityTypeLabel>
      </EntityLabelContainer>
      <EntityFeedContainer>
        {contents.map(item => (
          <ContentCard key={`${entity.name}-content-${item.title}`} data={item} />
        ))}
      </EntityFeedContainer>
    </EntitySection>
  );
};

export default EntityContentBlock;
